<template>
  <div class="user-nav ">
    <div class="user-nav-content">
      <div class="user-nav-left noSelect">
        <div class="user-nav-let-top">
          <div class="avatar-box">
            <img class="avatar" :src="site.avatar ? API_URL + user.avatar : IMG_URL + 'images/avatar.png'" alt="" />
          </div>
          <div class="order-conform" @click="onJumpPage('/order/add')"><img class="send-icon" :src="IMG_URL + 'images/icons/send.png'" alt="" />我要发货</div>
          <div class="order-conform" @click="onJumpPage('/order/lst')"><img class="send-icon" :src="IMG_URL + 'images/icons/send.png'" alt="" />订单列表</div>
          <div class="order-conform" @click="onJumpPage('/order/packagelst')"><img class="send-icon" :src="IMG_URL + 'images/icons/send.png'" alt="" />包裹列表</div>
          <div class="order-conform" @click="onJumpPage('/recharge')"><img class="send-icon" :src="IMG_URL + 'images/icons/send.png'" alt="" />立即充值</div>
        </div>

        <slot name="user-nav-let-center"></slot>
        <div class="user-nav-let-other">
          <img class="vcode-icon" :src="site.weixin_qrcode ? API_URL + site.weixin_qrcode : IMG_URL + 'images/icons/ercode.png'" alt="" />
          <div class="vcode-tips">在线客服(扫码加微信)</div>
        </div>
        <div class="fix" :style="`background-image: url('${IMG_URL}images/downloadSoft.png');background-size: 100% 50px;height: 50px;margin-top:10px;`" @click="openSoft"></div>

        <div
          v-if="advert.left1 && advert.left1.images && isShowAdv"
          class="user-nav-left-advert"
          :style="`background-image: url('${API_URL + advert.left1.images}')`"
          @click="onJumpPage(advert.left1.link)"
        ></div>
        <div
          v-if="advert.left2 && advert.left2.images && isShowAdv"
          class="user-nav-left-advert"
          :style="`background-image: url('${API_URL + advert.left2.images}')`"
          @click="onJumpPage(advert.left2.link)"
        ></div>
        <div
          v-if="advert.left3 && advert.left3.images && isShowAdv"
          class="user-nav-left-advert"
          :style="`background-image: url('${API_URL + advert.left3.images}')`"
          @click="onJumpPage(advert.left3.link)"
        ></div>
        <div
          v-if="advert.left4 && advert.left4.images && isShowAdv"
          class="user-nav-left-advert"
          :style="`background-image: url('${API_URL + advert.left4.images}')`"
          @click="onJumpPage(advert.left4.link)"
        ></div>
      </div>
      <div class="user-nav-right noSelect" v-if="isShowUser">
        <div class="user-nav-right-item">昵称：{{ user.nickname }}</div>
        <div class="user-nav-right-item">赠金：￥{{ user.cash || "0.00" }}</div>
        <div class="user-nav-right-item" v-if="user.level_name != '分站加盟'">
          用户等级：{{ user.level_name }} <a class="btn" href="javascript:void(0);" @click="onJumpPage('/service')">升级会员</a>
        </div>
        <div class="user-nav-right-item" v-else>用户等级：**** <a class="btn" href="javascript:void(0);" @click="onJumpPage('/service')">升级会员</a></div>

        <div class="user-nav-right-item">账户余额：￥{{ user.money || "0.00" }}元 <a class="btn" href="javascript:void(0);" @click="onJumpPage('/recharge')">立即充值</a></div>
        <div class="user-nav-right-item">
          实名认证：
          <span v-if="user.real_check_id > 0">已实名</span>
          <a class="btn" v-else href="javascript:void(0);" @click="onealCheck">去实名</a>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" :before-close="handleClose" class="real-men noSelect" width="340px">
      <div class="real-men-title" slot="title">请扫码认证</div>
      <div class="real-box">
        <div ref="qrCodeUrl" class="qrcode" />
        <p class="qr-tips-one">(如已认证，无须继续扫码)</p>
        <p class="qr-tips-tow">需要实名认证才能下单自提仓库</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="btn btn-style-3" @click="handleClose">稍后操作</div>
        <div class="btn btn-style" @click="handleClose">我已认证</div>
      </span>
    </el-dialog>

    <loading ref="loading" />
  </div>
</template>

<script>
import { getToken } from "@/api/auth";
import { apiGetRealQrcode, apiCheckReal } from "@/api/api";
import QRCode from "qrcodejs2";

export default {
  name: "userNav",
  props: {
    isShowUser: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeFun: null,
      dialogVisible: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user_info;
    },
    site() {
      return this.$store.getters.site;
    },
    isShowAdv() {
      console.log(this.$route.name);
      if (this.$route.name === "user" || this.$route.name === "walletLog" || this.$route.name === "packagelst" || this.$route.name === "recharge" || this.$route.name === "orderList") {
        return true;
      } else {
        return false;
      }
    },
    advert() {
      let info = null;
      let advert = {};
      if (this.$store.getters.advert) {
        info = this.$store.getters.advert;
      } else {
        info = localStorage.getItem("advertConfig");
        if (info) {
          info = JSON.parse(info);
        }
      }
      if (info) {
        for (let i = 0; i < info.member.length; i++) {
          advert[info.member[i].key] = info.member[i];
        }
      }
      console.log(advert);
      return advert;
    },
  },
  mounted() {},
  methods: {
    onJumpPage(url) {
      this.$router.push(url);
    },
    handleClose() {
      this.dialogVisible = false;
      clearInterval(this.timeFun);
      location.reload();
    },
    getCheckReal() {
      apiCheckReal().then(res => {
        if (res.code === 1) {
          clearInterval(this.timeFun);
          this.$message.success("实名成功");
        }
      });
    },
    creatQrCode(url) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 240,
        height: 240,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      this.$refs.loading.close();
    },
    onealCheck() {
      this.dialogVisible = true;
      this.$refs.loading.open();
      apiGetRealQrcode({ is_qrcode: 0 }).then(res => {
        this.creatQrCode(res.data.url);
        this.timeFun = setInterval(() => {
          this.getCheckReal();
        }, 2000);
      });
    },
    openSoft() {
      window.open("https://g85nhv7weo.feishu.cn/file/boxcnoppF6Vl66asfGdHs45EMJf", "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.user-nav {
  min-width: 1300px;
  // background-color: #0f375a;
  height: 80px;

  .user-nav-content {
    width: 1300px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .user-nav-left {
      position: absolute;
      left: 0;
      top: 0;

      .user-nav-let-top {
        width: 160px;
        height: 275px;
        background-color: rgba(249, 192, 61, 0.9);
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;

        .avatar-box {
          padding: 10px 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
        }

        .user-nav-let-tips {
          font-size: 12px;
          color: #000;
          padding: 10px 20px;
          font-weight: 400;
        }

        .order-conform {
          width: 100%;
          height: 50px;
          background-color: #0f375a;
          color: #ffffff;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;

          .send-icon {
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
        }
      }

      .user-nav-let-other {
        margin-top: 10px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .vcode-icon {
          width: 140px;
          height: 140px;
          margin: 5px 0;
        }
        .vcode-tips {
          font-size: 12px;
          font-weight: 400;
          color: #000000;
          height: 25px;
        }
      }

      .user-nav-left-advert {
        width: 100%;
        height: 50px;
        margin-top: 10px;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% 100%;
      }
    }

    .user-nav-right {
      flex: 1;
      margin-left: 180px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .user-nav-right-item {
        font-size: 14px;
        color: #ffffff;
        display: flex;
        align-items: center;

        .btn {
          margin-left: 5px;
          font-size: 12px;
          width: 80px;
          height: 20px;
          background-color: #ffffff;
          color: #000000;
          line-height: 20px;
          text-align: center;
        }
      }
    }
  }

  .real-box {
    background-color: #ffffff;
    padding: 30px 30px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      margin: 0;
      text-align: center;
      color: #000;
    }

    .qr-tips-one {
      color: #919191;
    }
    .qr-tips-tow {
      color: #000;
      margin-top: 20px;
    }
    .qrcode {
      margin-bottom: 10px;
    }
  }
  .real-men-title {
    text-align: center;
    font-size: 14px;
    color: #ffffff;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    padding: 0;

    .btn {
      width: 48%;
    }
  }
}
</style>

<style>
/*.real-men .el-dialog__header {*/
/*  display: none !important;*/
/*}*/

.real-men .el-dialog__body {
  padding: 0;
}

.real-men .el-dialog {
  /*width: 263px!important;*/
}

.real-men .el-dialog__footer {
  text-align: center;
}
.qrcode {
  width: 240px;
  height: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/userNav/index.vue